import Swal from "sweetalert2";
import { Button, Grid } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { InputFormQR } from "components/ui/qrInputText";
export const QrScannerTribunal = () => {
  const methods = useForm();
  const onSubmit = (data: any) => {
    let paramsQR = data.qr.split("/");
    if (!data.qr || data.qr.trim() === "") return;
    methods.reset({ qr: "" });
    Swal.fire({
      title: "Código leído correctamente",
      text: "¿Quieres abrir el sitio?",
      icon: "success",
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#00ce6f",
    }).then((result) => {
      if (result.isConfirmed) {
        const parametros: any = {
          cveQr: paramsQR?.[paramsQR?.length - 1],
        };
        const url = new URL("http://localhost:3030/qr-scanned");

        for (const key in parametros) {
          if (parametros.hasOwnProperty(key)) {
            url.pathname += `/${parametros[key]}`;
          }
        }
        window.open(url.toString(), "_blank");
      }
    });
  };

  return (
    <Grid container spacing={2}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid item sm={12}>
            <Button
              type="button"
              color="primary"
              variant="contained"
              onClick={() => {
                methods.setFocus("qr");
              }}
            >
              Presiona Aquí para empezar a Escanear
            </Button>
          </Grid>
          <Grid item sm={12}>
            <InputFormQR name="qr" label="QR" />
          </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
};
